// Owl & Twig — appends Log in + social links to the mobile menu drawer
(function () {
  'use strict';

  var INSTAGRAM_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="2" y="2" width="20" height="20" rx="5"></rect>' +
    '<circle cx="12" cy="12" r="4.5"></circle>' +
    '<circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"></circle>' +
    '</svg>';

  function init() {
    var drawers = document.querySelectorAll('.menu-drawer');
    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];
      if (drawer.querySelector('.owt-drawer-extras')) continue;
      var nav = drawer.querySelector('.menu-drawer__navigation');
      if (!nav) continue;

      var extras = document.createElement('div');
      extras.className = 'owt-drawer-extras';
      extras.innerHTML =
        '<a class="owt-drawer-login" href="/account/login">Log in</a>' +
        '<div class="owt-drawer-socials">' +
        '<a href="https://www.instagram.com/owlandtwigvintage" target="_blank" rel="noopener" aria-label="Instagram">' + INSTAGRAM_SVG + '</a>' +
        '<a href="https://www.etsy.com/shop/owlandtwigvintage" target="_blank" rel="noopener" aria-label="Etsy shop"><span class="owt-etsy">Etsy</span></a>' +
        '</div>';
      nav.insertAdjacentElement('afterend', extras);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
